/* Вид плавающей панели — общий с dropdown-menu, см. `../surface.module.css`. */
.content {
  composes: floating from '../surface.module.css';
}
